import { render, staticRenderFns } from "./AdminExamSettingsDatesIndex.vue?vue&type=template&id=4773ce60"
import script from "./AdminExamSettingsDatesIndex.vue?vue&type=script&lang=js"
export * from "./AdminExamSettingsDatesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports